import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Volume2, Speaker, Radio } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function AudioPreviewSection() {
  const navigate = useNavigate();

  const handleNavigateToSmartHome = () => {
    navigate("/smarthome#audio");
  };

  const handleNavigateToAudio = () => {
    navigate("/audio");
  };

  return (
    <section className="py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Volume2 className="h-8 w-8 text-primary" />
            <h2 className="text-3xl font-bold">Loxone Audio Systemen</h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Professionele multiroom audio met kristalheldere geluidskwaliteit door het hele huis
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Audio/610149%20-%20Install%20Speaker%207%20Master/Images/vi-overview-610149-install-speaker-7-master.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Install Speaker 7 Master</h3>
              <p className="text-muted-foreground text-sm">
                Premium inbouwspeakers met master-client architectuur voor optimale geluidsdistributie
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Audio/610001%20-%20WALL%20Speaker/Images/vi-overview-610001-wallspeaker-anthrazit.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Wall Speaker Collection</h3>
              <p className="text-muted-foreground text-sm">
                Elegante wandspeakers in zwart en wit voor naadloze integratie in elk interieur
              </p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="aspect-video bg-muted">
              <video 
                className="w-full h-full object-cover"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="https://pim.loxone.com//01%20Product%20Data/01%20Products/Audio/610155%20-%20Satellite%20Speaker%20IP64%20Passive/Images/vi-overview-610155-satellite-speaker-IP64-anthrazit.webm" type="video/webm" />
                Video niet ondersteund
              </video>
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold mb-2">Satellite Speaker IP64</h3>
              <p className="text-muted-foreground text-sm">
                Weersbestendige speakers voor buitentoepassingen met IP64 bescherming
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={handleNavigateToAudio} size="lg" className="px-8">
            Bekijk Audio Diensten
          </Button>
          <Button onClick={handleNavigateToSmartHome} variant="outline" size="lg" className="px-8">
            Audio in Smart Home
          </Button>
        </div>
      </div>
    </section>
  );
}